import { useContext } from 'react';
import { appWeb } from '@shd/jslib/ui';
import { UserContext } from './context';

export function GetUserContextFromStore(): appWeb.AppHostUserContextResponse {
  const userStore = useContext(UserContext);
  const authUser = userStore.authUser;
  const user = userStore.user;

  if (!authUser || !user || !user._id) {
    throw new Error('UserContext not available in web');
  }

  return {
    shdUserId: userStore.user._id,
    phone: userStore.userPhone,
    isLoggedIn: true,
    email: userStore.user.email,
    name: userStore.user.nameFirst,
  };
}
